import { create } from 'zustand';

interface UiStore {
  sidebarOpen: boolean;
  openSidebar:  () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
  agentActive: boolean;
  setAgentActive: (v: boolean) => void;
}

export const useUiStore = create<UiStore>((set) => ({
  sidebarOpen:   false,
  openSidebar:   () => set({ sidebarOpen: true }),
  closeSidebar:  () => set({ sidebarOpen: false }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  agentActive:   true,
  setAgentActive: (v) => set({ agentActive: v }),
}));
